import {FilterXSS} from "xss";

let prevTarget;
let saveTimer = 0;
let deleteTimer = 0;
let interval = 500;
const tagsForSave = [];
const tagsForDelete = [];

const myxss = new FilterXSS({
    whiteList: {}
});

const Subtract = require('array-subtract');
const subtract = new Subtract((a, b) => {
    return a === b
});

declare const $: any;

export default function AgGridTagsQtip(args) {
    if (prevTarget === args.target || !args.target) {
        return
    }
    if (prevTarget) {
        $(prevTarget).css("background-color", "#e4e4e4").css("background-image", "linear-gradient(to bottom, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%)");
        $(prevTarget).qtip("destroy");
        args.gridOptions.api.redrawRows({rowNodes: [args.rowNode]});
    }

    $(".qtip").remove();
    $('[data-hasqtip]').qtip('destroy', true);

    const $select = $(`<input />`).val(args.item.tags ? args.item.tags : []);

    $(args.target).qtip({
        content: {
            title: function () {
                return `<div title="Tags of ${myxss.process(args.item.name)}" style="width:360px; overflow:hidden; display:inline-block; text-overflow: ellipsis; white-space: nowrap;">Tags of ${myxss.process(args.item.name)}</div>`
            },
            text: $select,
            button: "Close"
        },
        show: true,
        hide: "unfocus",
        position: {
            my: 'top right',
            at: 'right center',
            viewport: $(`#${args.viewportId}`)
        },
        events: {
            show: () => {
                $(args.target)
                    .css("background-color", "#1AB394")
                    .css("background-image", "none");
                prevTarget = args.target;
                $("#tags_input").click();
            },
            hide: (event) => {
                $(prevTarget)
                    .css("background-color", "#e4e4e4")
                    .css("background-image", "linear-gradient(to bottom, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%)");

                if ($($select).data("select2")) {
                    $select.select2("destroy", event);
                }
                prevTarget = null;
                args.gridOptions.api.redrawRows({rowNodes: [args.rowNode]});
            },

            render: () => {
                $select.select2({
                    width: "100%",
                    tags: args.tagsList,
                    closeOnRemove: false,
                    tokenSeparators: ['  '],
                    placeholder: "Add Tag",
                    dropdownCssClass: "bigdrop",
                    createSearchChoice: function (term) {
                        const tagsArray = $select.val().split(",");
                        if (tagsArray.findIndex(elem => elem.toLowerCase() === term.toLowerCase()) !== -1 || args.tagsList.findIndex(elem => elem.toLowerCase() === term.toLowerCase()) !== -1 || term.includes(","))
                            return null;
                        return {id: $.trim(term), text: $.trim(term)};
                    }
                });

                $(".qtip-content .select2-choices li:last-child input")
                    .attr("id", "tags_input")
                    .attr("placeholder", "Add Tag");

                $select.on("select2-open", function () {
                    $(".bigdrop")
                        .css("position", "unset")
                        .css("height", "95px")
                        .css("width", "100%")
                        .appendTo($(".qtip-content"));
                    $(".select2-drop ul").height("100%");
                    $(args.target).qtip("reposition");
                });

                $select.on("select2-removed", (event) => {
                    tagsForDelete.push(event.val);
                    clearTimeout(deleteTimer);
                    deleteTimer = setTimeout(function () {
                        args.deleteTags(args.item.tags.concat(tagsForDelete), tagsForDelete);
                        tagsForDelete.length = 0;
                    }, interval);
                    args.item.tags.splice(args.item.tags.indexOf(event.val), 1);
                });

                $select.on("select2-selecting", (event) => {
                    tagsForSave.push(event.val);
                    clearTimeout(saveTimer);
                    saveTimer = setTimeout(function () {
                        args.saveTags(subtract.sub(args.item.tags, tagsForSave), tagsForSave);
                        tagsForSave.length = 0;
                    }, interval);
                    if (args.item.tags) {
                        args.item.tags.push(event.val)
                    } else {
                        args.item.tags = [event.val]
                    }
                });

                $select.on("select2-closing", (event) => {
                    if (event.originalEvent) {
                        switch (event.originalEvent.type) {
                            case "mousedown":
                            case "click":
                                break;
                            default:
                                event.preventDefault();
                        }
                    }
                });

                $select.on("select2-close", () => {
                    $(args.target).qtip("destroy");
                });

                $(".qtip-content .select2-choices").each(function () {
                    this.style.setProperty('height', '150px', 'important');
                    this.style.setProperty('overflow-y', 'auto', 'important');
                });
            }
        },
        style: {
            classes: 'qtip-dark',
            width: 400
        }
    })
}



// WEBPACK FOOTER //
// ./app/components/bo-core/common/AgGridTagsQtip.ts